import { FileExcelFilled } from '@ant-design/icons';
import { Button, Card, Row, Table } from 'antd';
import { Excel } from 'antd-table-saveas-excel';
import { ColumnProps } from 'antd/es/table';
import { bankNamesServices } from 'libs/shared-services/masters/src/lib/vendor-banks.service';
import React from 'react';
import { useEffect, useState } from 'react';
import { render } from 'react-dom';
import { Link } from 'react-router-dom';

export const VendorBanksView = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const service = new bankNamesServices();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = () => {
    service.getBankNames().then((res) => {
      if (res.status) {
        setData(res.data);
      }
    });
  };

  const columns: any[] = [
    {
      title: 'S No',
      key: 'sNo',
      responsive: ['sm'],
      render: (text, object, index) =>
        (page - 1) * pageSize + (index + 1) + pageSize * (page - 1),
    },
  
    {
      title: 'Bank Names',
      dataIndex: 'bankName',
      // align:'right'
    },


  ];

  let i = 1;
  const exceldata = [

    { title: 'S No', dataIndex: 'sNo', render: (text, object, index) => { 
      return index+1
   },
   width: 60, 
  
 },
    
    {
      title: 'Bank Names',
      dataIndex: 'bankName',
      render: (text: any, record: any) => {
        return record.bankName ? record.bankName : '-';
      },
    },
   
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('Vendor Banks Excel')
      .addColumns(exceldata)
      .addDataSource(data, { str2num: true })
      .saveAs('Vendor_Bank_Names.xlsx');
  };
  return (
    <Card
      title="Vendor Banks"
      extra={
        <Link to="/vendor-banks-excel-upload">
          <span style={{ color: 'white' }}>
            <Button type={'primary'}>Upload Excel</Button>{' '}
          </span>
        </Link>
      }
    >
      <Row justify={'end'}>
        <Button
          type="default"
          style={{ color: 'green' }}
          onClick={exportExcel}
          icon={<FileExcelFilled />}
        >
          Download Excel
        </Button>
      </Row>
      <Table
        className="custom-table-wrapper"
        columns={columns}
        dataSource={data}
        size="small"
        pagination={{
          pageSize: 100,
          onChange(current, pageSize) {
            setPage(current);
            setPageSize(pageSize);
          },
        }}
      />
    </Card>
  );
};

export default VendorBanksView;
